export default __webpack_public_path__ + "static/biohazard_b.6e403b2ec98f0b5d23109f254cb287f4.svg";